import api from "./api";

import { IDetailsBoleto } from "interfaces/detailsBoleto";
import { IDetailsPix } from "interfaces/detailsPix";
import { ITipoPagamento } from "interfaces/payment";
import { IDetailsCartaoEfi } from "interfaces/detailsCartao";

export async function getDetailBoleto(
  chargeid: number
): Promise<IDetailsBoleto> {
  try {
    const detailsBoleto = await api.post("/payment/detail-boleto", {
      chargeid,
    });
    return detailsBoleto.data;
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

export async function getDetailCartaoCredito(
  chargeId: number
): Promise<IDetailsCartaoEfi> {
  try {
    const detailsCartao = await api.post("/payment/detail-card", { chargeId });
    return detailsCartao.data;
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

export async function getDetailPix(txid: string): Promise<IDetailsPix> {
  try {
    const detailsPix = await api.post("/payment/detail-pix", { txid });
    return detailsPix.data;
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

export async function getAllPaymentActive() {
  try {
    const { data, status } = await api.get<ITipoPagamento[]>("/payment-taxas");
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}

export async function updatePaymentAndTaxa(
  payId: number,
  dataUpdate: Partial<ITipoPagamento>
) {
  try {
    const { data, status } = await api.put<ITipoPagamento>(
      `/payment-taxas/${payId}`,
      dataUpdate
    );
    return { data, status };
  } catch (error: any) {
    throw new Error(error.message || "Falha na comunicação");
  }
}
